import React from "react";
import "./header.scss";
import { useNavigate } from "react-router-dom";

const Header = ({ selectedCategory = "Philanthropy" }) => {
  const navigate = useNavigate();

  const token = window.localStorage.getItem("access_token");
  const flag = window.localStorage.getItem("flag");
  const userLoggedIn = token && flag === "member";

  return (
    <div className="navbar">
      <ul>
        {/* Conditional navigation based on selectedCategory */}
        {/* <li
          onClick={() =>
            selectedCategory === "Investment"
              ? navigate("/")
              : navigate("/Philanthropy")
          }
        >
          {selectedCategory}
        </li> */}
        <li onClick={() => navigate("/faq")}>FAQs</li>
        {/* if user is logged in then give maring left of 1rem */}
        <li onClick={() => navigate("/")}>
          <div className="logo">{/* <img src={logo} alt="logo" /> */}</div>
          <div className="name"></div>
        </li>
        {/* {userLoggedIn ? <li></li> : ""} */}
        {userLoggedIn ? (
          <li
            onClick={() => navigate("/dashboard/booking")}
            className="navItem"
          >
            Dashboard
          </li>
        ) : (
          <li onClick={() => navigate("/login")} className="navItem">
            Login
          </li>
        )}
      </ul>
    </div>
  );
};

export default Header;
